<template>
<div>
    <vue-perfect-scrollbar class="chat-history--scrollbar" ref="chat_scroll" :settings="scrollbar_settings">
        <v-list two-line class="chat-history--list">
            <template v-for="(item, index) in comments">
                <v-list-item class="chat-list" v-bind:class="{ 'light-green lighten-5': (index == comments.length - 1 && item.UserName != myName && todayMessage(item.CreatedDate)), 'sms-private': (item.Type === 2) }" :key="item.ID">
                    <v-list-item-avatar v-if="item.UserName != myName">
                        <img :src="item.RoleType | comment_avatar">
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle v-bind:class="{ 'sms-align-right': item.UserName == myName}" v-html="getTitle(item.UserName ?  item.UserName : '' + item.CustomerName ? item.CustomerName : '', item.CreatedDate)"></v-list-item-subtitle>
                        <div class="message-content-wrapper" v-bind:class="{ 'message-mine': item.UserName == myName}">
                            <p v-if="item.Media !== 1" v-bind:class="{ 'sms-align-right': item.UserName == myName}">{{ item.Comment }}</p>
                            <div v-else v-bind:class="{ 'sms-align-right': item.UserName == myName}">
                                <img :src="item.Comment" class="chat-image" @click="openImagePreview(item.Comment)" />
                            </div>
                            <v-btn v-if="item.UserName == myName" icon x-small class="delete-message-btn" @click="confirmDeleteMessage(item)" title="Xóa tin nhắn">
                                <v-icon x-small color="red">fa-trash</v-icon>
                            </v-btn>
                        </div>
                    </v-list-item-content>
                    <v-list-item-avatar v-if="item.UserName == myName">
                        <img :src="item.RoleType | comment_avatar">
                    </v-list-item-avatar>
                </v-list-item>
                <v-divider :key="`divider-${index}`" v-if="index < comments.length - 1"></v-divider>
            </template>
        </v-list>
    </vue-perfect-scrollbar>
    <v-divider></v-divider>
    <v-layout row class="pt-2">
        <v-select class="sms-dest" label="Khu vực gửi tin" v-model="selectedArea" :items="areas" item-text="name" item-value="value"></v-select>
        <div class="sms-input-wrapper">
            <input type="file" ref="fileInput" accept="image/*" style="display: none" @change="onFileSelected" />
            <v-btn icon small class="mr-2" @click="$refs.fileInput.click()" title="Chọn ảnh">
                <v-icon small>fa-image</v-icon>
            </v-btn>
            <v-text-field 
                ref="messageInput"
                class="sms-input" 
                append-icon="fa-paper-plane" 
                v-model="message" 
                label="Nhập tin nhắn cho đơn hàng" 
                @click:append="onSendMessage" 
                @keyup.enter="onSendMessage"
                @paste="onPaste"
            >
                <v-icon slot="append-icon">fa-paper-plane</v-icon>
            </v-text-field>
        </div>
    </v-layout>
    
    <confirm-dialog
      :dialog.sync="dialogConfirmDelete"
      title="Xác nhận xóa tin nhắn"
      :message="deleteMessage"
      color="error"
      icon="fa-trash"
      @confirm="executeDeleteMessage"
    ></confirm-dialog>
    
    <v-dialog v-model="imagePreviewDialog" max-width="800">
        <v-card>
            <v-card-text class="pa-0">
                <img :src="previewImageUrl" style="width: 100%; height: auto;" />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="imagePreviewDialog = false">Đóng</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    
    <v-overlay :value="uploading" z-index="999999">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="white--text mt-3">Đang tải ảnh lên...</div>
    </v-overlay>
</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import moment from "moment"
import configs from '@/configs'
import _, { first } from "lodash";
import {
    mapState
} from "vuex";
import {
    comment_avatar,
    comment_type,
    comment_type_color,
} from "@/commons/hpod";
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
    name: 'message-box',
    filters: {
        comment_type,
        comment_type_color,
        comment_avatar,
    },
    components: {
        VuePerfectScrollbar,
        "confirm-dialog": ConfirmDialog,
    },
    props: {
        orderId: {
            type: Number,
            default: 0
        },
        orderType: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            message: "",
            timer: "",
            selectedArea: 1,
            firstLoad: true,
            scrollbar_settings: {
               wheelPropagation: true
            },
            uploading: false,
            imagePreviewDialog: false,
            previewImageUrl: "",
            dialogConfirmDelete: false,
            selectedMessageToDelete: null
        }
    },
    computed: {
        ...mapState("orderComment", {
            comments: "all"
        }),
        myName() {
            return this.$store.state.authentication.user.username;
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        storeTQRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        areas() {
            // return this.storeVNRole || this.storeTQRole ? _.find(configs.COMMENT_TYPE, {value: 2}) : configs.COMMENT_TYPE;
            return configs.COMMENT_TYPE;
        },
        deleteMessage() {
            if (!this.selectedMessageToDelete) return '';
            const isImage = this.selectedMessageToDelete.Media === 1;
            const contentType = isImage ? 'ảnh' : 'tin nhắn';
            return `<p class="mb-2">Bạn có chắc chắn muốn xóa ${contentType} này?</p><p class="mb-0 grey--text text--darken-1">Thao tác này không thể hoàn tác.</p>`;
        }
    },
    watch: {
        orderId() {
            this.fetchData();
        },
        comments() {
            if (this.firstLoad) {
                this.scrollToEnd();
                this.firstLoad = false;
            } 
        }
    },
    methods: {
        todayMessage(createTime) {
            return moment(createTime).startOf('day').isSame(moment().startOf('day'));
        },
        scrollToEnd() {
            setTimeout(() => {
                const container = this.$el.querySelector('.ps-container');
                container.scrollTop = container.scrollHeight;
            }, 0);
        },
        fetchData: _.debounce(function () {
            this.$store.dispatch("orderComment/getOrderCommentList", {id: this.orderId, type: this.orderType});
        }, 1000, {
            'leading': true,
            'trailing': false
        }),
        onSendMessage() {
            if(this.message != "") {
                this.sendTextMessage();
            }
        },
        sendTextMessage() {
            this.$store.dispatch("orderComment/putOrderComment", {
                'OrderID': this.orderId,
                'Comment': this.message,
                'Status': 0,
                'Type': this.selectedArea,
                'OrderType': this.orderType !== '' ? this.orderType : null,
                'UserID': this.$store.state.authentication.user.userid,
                'Media': 0
            });
            this.message = "";
            this.scrollToEnd();
        },
        async uploadAndSendImage(file) {
            this.uploading = true;
            try {
                const result = await this.$store.dispatch("commons/uploadFile", {
                    file: file
                });
                
                if(result.success) {
                    this.$store.dispatch("orderComment/putOrderComment", {
                        'OrderID': this.orderId,
                        'Comment': result.url,
                        'Status': 0,
                        'Type': this.selectedArea,
                        'OrderType': this.orderType !== '' ? this.orderType : null,
                        'UserID': this.$store.state.authentication.user.userid,
                        'Media': 1
                    });
                    this.scrollToEnd();
                }
            } catch(error) {
                console.error('Upload error:', error);
            } finally {
                this.uploading = false;
            }
        },
        onFileSelected(event) {
            const file = event.target.files[0];
            if(file && file.type.startsWith('image/')) {
                this.uploadAndSendImage(file);
                this.$refs.fileInput.value = '';
            }
        },
        onPaste(event) {
            const items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    event.preventDefault();
                    const blob = items[i].getAsFile();
                    this.uploadAndSendImage(blob);
                    break;
                }
            }
        },
        openImagePreview(imageUrl) {
            this.previewImageUrl = imageUrl;
            this.imagePreviewDialog = true;
        },
        confirmDeleteMessage(item) {
            this.selectedMessageToDelete = item;
            this.dialogConfirmDelete = true;
        },
        executeDeleteMessage() {
            if (this.selectedMessageToDelete) {
                this.$store.dispatch("orderComment/removeDetail", this.selectedMessageToDelete.ID);
                setTimeout(() => {
                    this.$store.dispatch("orderComment/getOrderCommentList", {
                        id: this.orderId,
                        type: this.orderType
                    });
                }, 300);
            }
            this.dialogConfirmDelete = false;
            this.selectedMessageToDelete = null;
        },
        getTitle(user_name, send_time) {
            return "<span class='text--primary font-weight-bold'>"+user_name+"</span>: " + moment.utc(send_time).utcOffset(7 * 60).format("DD-MM-YYYY HH:mm:ss")
        }
    },
    mounted() {
        // this.selectedArea = this.storeVNRole || this.storeTQRole ? 2 : 1;
        this.selectedArea = 1;
        this.fetchData();
    },
    created() {
        this.timer = setInterval(this.fetchData, 1000*configs.SYSTEM_CONFIG.notification_time);
    },
    destroyed() {
        clearInterval(this.timer);
    }
}
</script>

<style scoped>
.v-list--two-line .v-list__tile {
    height: auto !important;
    padding: 5px 0 5px 0;
}

.sms-dest {
    width: 20vw;
    margin-left: 12px;
}

.sms-input-wrapper {
    display: flex;
    align-items: center;
    width: 80vw;
    margin-left: 8px;
    margin-right: 12px;
}

.sms-input {
    flex: 1;
}

.sms-align-right {
    text-align: right;
}

.sms-private {
    background-color: #FFDDDD
}

.chat-image {
    max-width: 300px;
    max-height: 300px;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s;
}

.chat-image:hover {
    transform: scale(1.05);
}

.message-content-wrapper {
    position: relative;
    display: inline-block;
}

.message-mine .delete-message-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.2s;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.message-content-wrapper:hover .delete-message-btn {
    opacity: 1;
}
</style>
